module.exports = __webpack_public_path__ + "img/moreinfo-lifestyle_0_0.0ad2a20a.jpg";